// AI Speaking Engine — DlaVia AIController proxy (HTTPS)
// AI_API_KEY    → Sunucu Web.config -> appSettings -> "AIApiKey" ile aynı olmalı
// AI_ADMIN_TOKEN → Python service env -> DLA_ADMIN_TOKEN ile aynı olmalı
//
// GÜVENLİK: Anahtarlar artık .env üzerinden okunuyor (REACT_APP_*).
// Kaynak kodda gizli anahtar tutulmaz. Aşağıdaki değerler yalnızca
// env tanımlı değilse devreye giren güvenli fallback'lerdir.
module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },

  AI_BASE:        process.env.REACT_APP_AI_BASE || "https://dlaviapi.stechomeyazilim.info/api/AI",
  AI_API_KEY:     process.env.REACT_APP_AI_API_KEY || "",
  AI_ADMIN_TOKEN: process.env.REACT_APP_AI_ADMIN_TOKEN || process.env.REACT_APP_ADMIN_TOKEN || "",

  // OData kök adresi (tüm /Users, /Contact, /Premium_Package vb. çağrılarının ortak tabanı).
  // Tek yerden değiştirmek için: REACT_APP_ODATA_BASE ile override edilebilir.
  ODATA_BASE:     process.env.REACT_APP_ODATA_BASE || "https://dlaviapi.stechomeyazilim.info",
};

// /Users gibi admin korumalı OData uçları için ortak header.
// Backend (UsersController) bu token'ı görünce TÜM kayıtları döndürür.
module.exports.ADMIN_HEADERS = {
  headers: { "X-Admin-Token": module.exports.AI_ADMIN_TOKEN },
};
